import AbsPopup from "commons/popup/display/AbsPopup";
import { PopupType } from "../PopupType";
import { UiInputDate } from "components/ui/InputDate";
import moment from "moment";
import { useAbsPopupTitle, useClosePopup } from "commons/popup/store/absPopupHook";
import styled from "styled-components";
import { UiInputFile } from "components/ui/InputFile";
import { ElementGroup } from "styles/components";
import Button from "components/ui/Button";
import { ButtonSize, ButtonType } from "components/ComponentsType";
import { ButtonState } from "commons/popup/store/absPopupVo";
import { useInsightMSNUpload } from "./CSVUploadHook";

const HeaderStyle = styled.div`
  padding: 16px 16px 0;
`;

const InsertFileStyle = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  width: 70%;

  button {
    background-color: #fff;
    border: 1px solid var(--border-dark);
    color: var(--font-primary);

    &:hover {
      opacity: 0.7;
      border: 1px solid var(--border-dark);
      background-color: #f7f7f7;
    }
  }

  input[type="text"] {
    text-align: right;
    border: none;
    background-color: #fff;
    padding-left: 16px;
    text-overflow: ellipsis;
    color: var(--font-grey);
  }
`;

const FooterStyle = styled(ElementGroup.Row)`
  border-top: 1px solid var(--border-primary);
  padding: 8px;
`;

/**
 * 팝업 헤더
 * @returns JSX.Element
 */
function CustomHeader(): JSX.Element {
  const { title } = useAbsPopupTitle(PopupType.CSV_UPLOAD_POPUP);

  return <HeaderStyle>{title}</HeaderStyle>;
}

/**
 * 팝업 푸터
 * @returns JSX.Element
 */
export function CustomButtonGroup(): JSX.Element {
  const { close } = useClosePopup(PopupType.CSV_UPLOAD_POPUP);

  const { upload } = useInsightMSNUpload();
  return (
    <FooterStyle flexContent="end">
      <Button
        text="취소"
        thin
        btnSize={ButtonSize.XSM}
        btnType={ButtonType.BORDER}
        onClick={close.bind(null, ButtonState.NO)}
      />
      <Button
        text="저장"
        thin
        btnSize={ButtonSize.XSM}
        onClick={() => {
          upload();
        }}
      />
    </FooterStyle>
  );
}

/**
 * 팝업 바디
 * @returns JSX.Element
 */
function CSVUploadPopup(): JSX.Element {
  return (
    <AbsPopup type={PopupType.CSV_UPLOAD_POPUP} header={<CustomHeader />} borderShape={8}>
      <ElementGroup.Row>
        <UiInputDate id="insert_date" init={moment(Date.now()).subtract(1, "days").format("YYYY-MM-DD")} />

        <InsertFileStyle>
          <UiInputFile id="insert_csv" buttonText="파일선택" placeholder="파일을 선택해 주세요" accept=".csv" />
        </InsertFileStyle>
      </ElementGroup.Row>
    </AbsPopup>
  );
}

export default CSVUploadPopup;
